import React, { useState } from "react";

import Moment from "moment";

import Languages from "../../../../translations";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";

const LeopsFollowUp = ({ supportPlanModel }) => {
  const [expanded, setExpanded] = useState(false);

  if (!supportPlanModel) return null;

  const SubModel = supportPlanModel;

  return (
    <Accordion
      className="painikkeet"
      style={{ backgroundColor: "#4377BA" }}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className="heading">
          {Languages.AdditionaMethods}
        </Typography>
      </AccordionSummary>
      <div style={{ backgroundColor: "#ffffff", color: "black" }}>
        {SubModel.Selection1Date && (
          <AccordionDetails>
            <div>
              {Languages.SupportMethodsAreEnough +
                ", " +
                Moment(SubModel.Selection1Date).format("DD.MM.YYYY")}
            </div>
            <strong>{Languages.SupportSelection1Header}</strong>
            <div>{SubModel.Selection1Text}</div>
          </AccordionDetails>
        )}

        {SubModel.Selection2Date && (
          <AccordionDetails>
            <div>
              {Languages.SupportMethodsNeedUpdating +
                ", " +
                Moment(SubModel.Selection2Date).format("DD.MM.YYYY")}
            </div>
            <strong>{Languages.SupportSelection2Header}</strong>
            <div>{SubModel.Selection2Text}</div>
          </AccordionDetails>
        )}

        {SubModel.Selection3Date && (
          <AccordionDetails>
            <div>
              {Languages.SupportMethodsNeedNewEvaluation +
                ", " +
                Moment(SubModel.Selection3Date).format("DD.MM.YYYY")}
            </div>
            <strong>{Languages.SupportSelection3Header}</strong>
            <div>{SubModel.Selection3Text}</div>
          </AccordionDetails>
        )}

        {SubModel.Selection4Date && (
          <AccordionDetails>
            <div>
              {Languages.ChildSupportNeedRemoved}
              {" , " + Moment(SubModel.Selection4Date).format("DD.MM.YYYY")}
            </div>
            <strong>{Languages.ChildSupportNeedRemovedQuestion}</strong>
            <div>{SubModel.Selection4Text}</div>
          </AccordionDetails>
        )}
      </div>
    </Accordion>
  );
};

export default LeopsFollowUp;
